import {
  ChangeDetectorRef,
  Component,
  HostBinding,
  Injector, OnInit,
  Optional
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {DISPLAY_TYPE, IWidgetConfig, Parent, register, StylableComponent, styler, WmComponentsModule } from "@wm/components-base";
import {encodeUrl, setAttr} from "@wm/core";


const DEFAULT_CLS = 'app-anchor';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-anchor',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: 'a[wmAnchor]',
  standalone: true,
  imports: [CommonModule, WmComponentsModule],
  template: `
    <img data-identifier="img" alt="Image" class="anchor-image-icon" [src]="iconurl | image" *ngIf="iconurl" [ngStyle]="{width:iconwidth, height:iconheight, margin:iconmargin}"/>
    <i class="app-icon {{iconclass}}" aria-hidden="true" [ngStyle]="{width:iconwidth, height:iconheight, margin:iconmargin}" *ngIf="iconclass"></i>
    <span class="sr-only" *ngIf="iconclass">{{caption}} {{appLocale.LABEL_ICON}}</span>
    <span class="anchor-caption" [innerHTML]="caption"></span>
    <ng-content select=".caret"></ng-content>
    <span *ngIf="badgevalue" class="badge pull-right" [textContent]="badgevalue"></span>
  `,
  styleUrls: ['./anchor.component.css'],
  exportAs: 'wmAnchor'
})
export class AnchorComponent extends StylableComponent {
  static initializeProps = register('wm-anchor');

  public iconmargin: string;
  public iconheight: string;
  public iconwidth: string;
  public iconurl: string;
  public iconclass: string;
  public caption: any;
  public show: any;
  public badgevalue: string;
  public bindbadgevalue: string;
  public encodeurl: boolean;
  // public override appLocale: any;
  private cdRef: ChangeDetectorRef;
  @HostBinding('attr.icon-position') iconposition: string = '';


  constructor( inj: Injector,
               @Optional() public _viewParent: Parent) {
    super(inj, WIDGET_CONFIG, _viewParent);
    styler(this.nativeElement, this);
  }

  override ngOnInit() {
    super.ngOnInit();
    if(!this.badgevalue)
      this.badgevalue = this.bindbadgevalue;
  }
  override onPropertyChange(key: string, nv: any, ov?: any) {
    if (key === 'hyperlink') {
      if (!nv) {
        setAttr(this.nativeElement, 'href', 'javascript:void(0)');
        return;
      }
      if (this.encodeurl) {
        nv = encodeUrl(nv);
      }
      // if hyperlink starts with 'www.' append '//' in the beginning
      if (nv.startsWith('www.')) {
        nv = `//${nv}`;
      }
      setAttr(this.nativeElement, 'href', nv);
    } else {
      super.onPropertyChange(key, nv, ov);
    }
  }

}
